<template>
  <div class="components-layout--cookies has-background-black-ter has-text-white-ter is-width-100" v-if="!required">
      <div class="container">
          <div class="components-layout--cookies__section section is-small is-flex-direction-row is-justify-content-space-between is-align-items-center">
              <p class="my-2">
                  {{ $t('wistro.cookies.info') }}
              </p>
              <div class="components-layout--cookies__buttons is-flex is-flex-direction-row is-justify-content-space-between is-align-items-center is-flex-wrap-wrap">
                  <div class="mb-2">
                      <button class="button is-dark mr-2 mt-2" data-modal-open=".modals--cookies-modal">
                        {{ $t('wistro.cookies.actions.adjust') }}
                      </button>
                  </div>
                  <div class="is-flex is-flex-wrap-wrap mb-2">
                      <button
                          class="button is-success is-block mt-2"
                          :class="{'is-loading': loadingAll}"
                          @click="acceptAll"
                      >{{ $t('wistro.cookies.actions.accept') }}
                      </button>
                  </div>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
import cookieGetters from '../../../store/web/cookie/getter-types';
import cookieActions from '../../../store/web/cookie/action-types';

export default {
  data() {
    return {
      loadingAll: false,
    };
  },
  methods: {
    acceptAll() {
      this.loadingAll = true;
      this.$store.dispatch('cookie/' + cookieActions.ACCEPT_ALL).then(() => {
        this.loadingAll = false;
      });
    }
  },
  computed: {
    required() {
      return this.$store.getters['cookie/' + cookieGetters.GET_REQUIRED];
    }
  }
}
</script>

<style>

</style>
